import * as React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
const SvgMeasureLine = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    props,
    <path d="M6 17H4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1ZM20 3h-2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1ZM16.07 6.51l-9.56 9.56a2 2 0 0 1 1.42 1.42l9.56-9.56a2 2 0 0 1-1.42-1.42Z" />
  )
export default SvgMeasureLine
